import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core'
import { MatRadioChange } from '@angular/material/radio'
import { Profile } from '../../../../interfaces/user'
import { HorizontalQuestion, HorizontalQuestionInput } from '../question'

@Component({
  selector: 'app-horizontal-question',
  templateUrl: './horizontal-question.component.html',
  styleUrls: ['../../../../../theme/radio-button.scss', '../question.scss', './horizontal-question.component.scss'],
})
export class HorizontalQuestionComponent extends HorizontalQuestion implements OnInit, OnChanges {
  @Input() questionNumber: number | undefined
  @Input() question: HorizontalQuestionInput | undefined
  @Input() disabled = false
  @Input() checkedOption: number | undefined
  @Input() compareOption: number | undefined
  @Input() optionValues: number[] | undefined
  @Output() selected = new EventEmitter<number>()

  @Input() compareCheckType?: 'check' | 'ticker' | 'image' = 'check'
  @Input() profile?: Profile
  @Input() respondentFirstName?: string
  @Input() imageUrl?: string

  options: number[] = []
  leftQuestionSelected = false
  rightQuestionSelected = false

  constructor() {
    super()
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('question') && this.question !== undefined) {
      this.options = new Array(this.question?.optionCount)
    }
    if (changes.hasOwnProperty('checkedOption') && this.checkedOption !== undefined) {
      this.setQuestionSelectedValues(this.checkedOption)
    }
  }

  onSelected($event: MatRadioChange): void {
    const selectedValue = $event.value
    this.selected.emit(selectedValue)
    this.setQuestionSelectedValues(selectedValue)
  }

  private setQuestionSelectedValues(selectedValue: number): void {
    if (this.question !== undefined && this.question !== null) {
      const optionCount = this.question.optionCount ?? this.optionValues?.length ?? 5
      if (optionCount % 2 === 1 && selectedValue + 1 === Math.round(optionCount / 2)) {
        this.leftQuestionSelected = false
        this.rightQuestionSelected = false
      } else if (selectedValue < optionCount / 2) {
        this.leftQuestionSelected = true
        this.rightQuestionSelected = false
      } else {
        this.rightQuestionSelected = true
        this.leftQuestionSelected = false
      }
    }
  }
}
